import { useLocation } from 'react-router'

import { MAP_TYPES } from '../constants/constants'
import { MapSubtypeId } from '../types'

/**
 * Hook which gets the current map type and subtype from the URL
 */
export function useMapType(typeGetter?: (query: URLSearchParams) => string | null) {
  const query = new URLSearchParams(useLocation().search)
  const typeFromQuery = typeGetter?.(query) ?? query.get('t')
  let subtypeFromQuery = query.get('st')

  // Handle renamed MtD crypto type
  if (subtypeFromQuery === 'w4td') subtypeFromQuery = MapSubtypeId.MonthToDatePerf

  const type = MAP_TYPES.find((t) => t.type === typeFromQuery) ?? MAP_TYPES[0]
  const subtypes = type.subtypes.flatMap((type) => type.items)
  const subtype =
    subtypes.find((subtype) => subtype.value === subtypeFromQuery) ??
    subtypes.find((subtype) => subtype.value === MapSubtypeId.DayPerf) ??
    subtypes[0]

  return { type, subtype }
}
